export enum NavBarVariant {
  PRIMARY = '--primary',
  ICON = '--icon',
  ICON_EXPANDED = '--primary --icon-expanded',
}
